// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
// REDUX
import timezone from 'moment-timezone';

const TIMEZONE = timezone.tz.guess() || 'America/New_York'; // guess users time zone

const Signature = ({
  signatureText, signDate, email, orgByUserId,
}) => {
  const date = signDate
    ? `signed on ${timezone(signDate)
      .tz(TIMEZONE)
      .format('dddd, MMMM D YYYY')}`
    : '';

  return (
    <div className="signature-container">
      <div className="signature-wrapper">
        <p className="signature-text">{signatureText}</p>
      </div>
      <p className="zero-font">{signatureText && signatureText}</p>
      <p className="zero-font">{orgByUserId && orgByUserId.title}</p>
      <p className="nine-font">{email || ''}</p>
      <p className="nine-font">{date || ''}</p>
    </div>
  );
};

const SignatureArea = ({ contractFlow }) => {
  const {
    clientEmail,
    contractorEmail,
    contractorSignature,
    clientSignature,
    clientSignDate,
    contractorSignDate,
    orgByUserId,
  } = contractFlow;
  return (
    <div style={{ minHeight: 225, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 2 }}>
        <h3 className="the-parties-hereto">
          THE PARTIES HERETO AGREE TO THE FOREGOING AS EVIDENCED BY THEIR SIGNATURES BELOW.
        </h3>
      </div>
      <div style={{ flex: 4 }}>
        <Row gutter={50} type="flex" align="middle" justify="center" className="contract-row">
          <Col xs={24} sm={12} className="contract-col">
            <Signature
              signatureText={contractorSignature}
              signDate={contractorSignDate}
              email={contractorEmail}
              orgByUserId={orgByUserId}
            />
          </Col>
          <Col xs={24} sm={12} className="contract-col">
            <Signature signatureText={clientSignature} signDate={clientSignDate} email={clientEmail} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

SignatureArea.propTypes = {
  'contractFlow.clientEmail': PropTypes.object,
  'contractFlow.clientSignDate': PropTypes.object,
  'contractFlow.clientSignature': PropTypes.object,
  'contractFlow.contractorEmail': PropTypes.object,
  'contractFlow.contractorSignature': PropTypes.object,
  'contractFlow.contractorSignDate': PropTypes.object,
};

SignatureArea.defaultProps = {
  clientEmail: '',
  clientSignature: '',
  contractorEmail: '',
  contractorSignature: '',
};

/* const mapStateToProps = ({ contractFlow }) => {
  console.log(contractFlow)
  return {
    clientEmail: contractFlow.clientEmail,
    clientSignature: contractFlow.clientSignature,
    contractorSignature: contractFlow.contractorSignature,
    contractorEmail: contractFlow.contractorEmail,
    clientSignDate: contractFlow.clientSignDate,
    contractorSignDate: contractFlow.contractorSignDate,
  }
} */
export default SignatureArea;

/*
// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
// REDUX
import { connect } from 'react-redux';
import * as actions from '/imports/ui/redux/actions';
import timezone from 'moment-timezone';

const TIMEZONE = timezone.tz.guess() || 'America/New_York'; // guess users time zone


const Signature = ({ signatureText, signDate, email, orgByUserId }) => {
  let date = signDate ? `signed on ${ timezone(signDate).tz(TIMEZONE).format('dddd, MMMM D YYYY') }` : ''
  return (
    <div className='signature-container'>
      <div className="signature-wrapper">
        <p className='signature-text'>
          { signatureText }
        </p>
      </div>
      <p style={{fontSize: 14, marginTop: 5, color: '#000'}}>
        { signatureText && signatureText }
      </p>
      <p style={{fontSize: 14, marginTop: 5, color: '#000'}}>
        { orgByUserId && orgByUserId.title }
      </p>
      <p style={{fontSize: 13, color: '#999', marginTop: 5}}>
        { email && email }
      </p>
      <p style={{fontSize: 13, color: '#999', marginTop: 5}}>
        { date }
      </p>
    </div>
  )
}


const SignatureArea = ({ contractFlow }) => {
  const {
      clientEmail,
      contractorEmail,
      contractorSignature,
      clientSignature,
      clientSignDate,
      contractorSignDate,
      orgByUserId
    } = contractFlow
  return (
    <div style={{minHeight: 225, display: 'flex', flexDirection: 'column'}}>
        <div style={{flex: 2}}>
          <h3 style={{marginTop: 55, fontSize: '10px', fontWeight: 700, marginBottom: 35}}>
            THE PARTIES HERETO AGREE TO THE FOREGOING AS
            EVIDENCED BY THEIR SIGNATURES BELOW.
          </h3>
        </div>
        <div style={{flex: 4}}>
          <Row gutter={50} type="flex" align="middle" justify="center">
            <Col xs={24} sm={12}>
              <Signature
                signatureText={contractorSignature.value}
                signDate={contractorSignDate.value}
                email={contractorEmail.value}
                orgByUserId={orgByUserId}
              />
            </Col>
            <Col xs={24} sm={12}>
              <Signature
                signatureText={clientSignature.value}
                signDate={clientSignDate.value}
                email={clientEmail.value}
              />
            </Col>
          </Row>
        </div>
      </div>
  )
}

SignatureArea.propTypes = {
  'contractFlow.clientEmail': PropTypes.object,
  'contractFlow.clientSignDate': PropTypes.object,
  'contractFlow.clientSignature': PropTypes.object,
  'contractFlow.contractorEmail': PropTypes.object,
  'contractFlow.contractorSignature': PropTypes.object,
  'contractFlow.contractorSignDate': PropTypes.object,
};

SignatureArea.defaultProps = {
  clientEmail: "",
  clientSignature: "",
  contractorEmail: "",
  contractorSignature: "",
};

/*const mapStateToProps = ({ contractFlow }) => {
  console.log(contractFlow)
  return {
    clientEmail: contractFlow.clientEmail,
    clientSignature: contractFlow.clientSignature,
    contractorSignature: contractFlow.contractorSignature,
    contractorEmail: contractFlow.contractorEmail,
    clientSignDate: contractFlow.clientSignDate,
    contractorSignDate: contractFlow.contractorSignDate,
  }
}//
export default SignatureArea
*/



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/SignatureArea/index.js